export enum AuthorizationState {
    AUTHORIZED = 'AUTHORIZED',
    EXPIRING_SOON = 'EXPIRING_SOON',
    EXPIRED = 'EXPIRED',
    UNAUTHORIZED = 'UNAUTHORIZED',
}
